import { NumberInputComponentV2 } from './number-input-v2.component';
import { UserService } from './../../../base-services/user.service';
import { ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Component } from '@angular/core';
import { MakeProvider } from '../../abstract-custom-control';
import { DecimalPipe } from '@angular/common';
@Component({
    selector: 'yt-number-input-v4',
    templateUrl: './number-input-v4.component.html',
    providers: [ MakeProvider(NumberInputComponentV4) ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberInputComponentV4 extends NumberInputComponentV2 {
    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected userService: UserService,
        protected decimalPipe: DecimalPipe
    ){
        super(changeDetectorRef, userService, decimalPipe);
    }

}